import React, { useState } from 'react';
import { TextField, Button, Grid, Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { USER_LOGIN_SUCCESS } from '../../actions/auth/type';
import { superLogin } from '../../api/users/superLogin';
import { Toast } from '../../components/Toast/Toast';

export default function SuperLogin() {
  const [userId, setUserId] = useState('');
  const [authKey, setAuthKey] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();
  const onSubmit = async () => {
    const {
      data: {
        data: { token },
      },
    } = await superLogin({ userToken: authKey, userId });
    if (token) {
      localStorage.setItem('userData', JSON.stringify(token));
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: token,
      });
      history.push('/dashboard');
    } else {
      Toast('error', 'Invalid key');
    }
  };
  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          name='UserId'
          label='User Id'
          placeholder='Enter User Id'
          onChange={(e) => setUserId(e.target.value)}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          name='AuthenticatorKey'
          label='Enter Auth Key'
          placeholder='Enter Auth key'
          onChange={(e) => setAuthKey(e.target.value)}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={12}>
        <Box display='flex' justifyContent='center'>
          <Button
            color='primary'
            className='submitConfirmButton'
            autoFocus
            onClick={onSubmit}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
